// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dw-tooltip{background:#1d243bec !important;color:#fff;font-family:'Poppins';font-weight:400 !important;font-size:14px !important;padding:6px;word-break:break-word;overflow-wrap:break-word}.dw-tooltip p{color:#fff}.dw-tooltip hr{border-color:#ffffff1a}.dw-tooltip--p0 .tippy-content{padding:0 !important}.dw-tooltip-icon{color:#b4bdd6}\n", ""]);
// Exports
module.exports = exports;
